import NoProjects from '../components/NoProjects';

const NoProjectsPage = () => {
    return <NoProjects />;
};

export default NoProjectsPage;
